import { createRouter, createWebHistory } from 'vue-router'
import AppointmentView from '../views/AppointmentView.vue'
import BookingView from '../views/BookingView.vue'

const routes = [
  {
    path: '/:location?',// /:location?
    name: 'home',
    meta: { title: 'Booking' },
    component: BookingView
  },
  {
    path: '/confirmation/:appointment', // /confirmation/:appointment
    name: 'appointment',
    meta: { title: 'Booking' },
    component: AppointmentView
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title + " – Leightons Opticians & Hearing Care";
  next();
});

export default router
